import { action } from '@ember/object';
import MarketSnapshotsBaseController from 'lumen/controllers/market/snapshots/base';
import type MarketSnapshotsTransientGroupRoute from 'lumen/routes/market/snapshots/transient-group';
import {
  type DataPreferences,
  SNAPSHOT_VIEW_CONFIG,
} from 'lumen/utils/constants/market-snapshots-constants';
import {
  apiOrderByChanged,
  remapOrderByMetric,
} from 'lumen/utils/market-snapshots/order-by';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSnapshotsTransientGroupController extends MarketSnapshotsBaseController {
  declare model: ModelFrom<MarketSnapshotsTransientGroupRoute>;

  readonly config = SNAPSHOT_VIEW_CONFIG['transient-group'];

  @action
  updateDataPreferences(preferences: DataPreferences): void {
    // sdlyColumn changes the API request;
    // variance changes the API order_by suffix if sortOn=variance.
    const sdlyColumnChanged =
      preferences.sdlyColumn !== this.dataPreferences.sdlyColumn;

    // A sort on a swapped column would otherwise be left pointing at a metric
    // that's no longer requested; repoint it to the equivalent new column.
    let orderBy = this.orderBy;
    if (sdlyColumnChanged) {
      orderBy = remapOrderByMetric(
        orderBy,
        this.dataPreferences.sdlyColumn,
        preferences.sdlyColumn,
      );
    }

    const varianceRefetch = apiOrderByChanged(
      orderBy,
      this.tableLayoutPreferences.sortOn,
      this.dataPreferences.variance,
      preferences.variance,
    );

    this.persistDataPreferences(preferences);

    if (orderBy !== this.orderBy) {
      // Setting a refreshModel QP (orderBy/page) refreshes the model on its own;
      // also calling router.refresh would abort that transition and revert it.
      this.orderBy = orderBy;
      this.page = 1;
    } else if (varianceRefetch) {
      this.refetchFromFirstPage();
    } else if (sdlyColumnChanged) {
      // The request changed but the URL didn't; refetch explicitly.
      this.refresh();
    }
  }
}
